import { Component, ViewChild } from '@angular/core';
import { environment } from 'environments/environment';
import { LoginService } from '../login/shared/login.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @ViewChild('sidenav') sidenav?: MatSidenav;

  public isProduction = environment.production;
  public isMobile = window.innerWidth < 960;

  constructor(public loginService: LoginService) {}

  public logout() {
    this.loginService.logout();
  }

  public closeSidenav() {
    if (this.sidenav) {
      this.sidenav.close();
    }
  }

  protected readonly localStorage = localStorage;
}
